/** Backend selection never changes the scene/model or starts parallel devices. */
export async function createPlanBackend({ preferred = 'auto', webgpuAvailable = false,
  create, isCurrent = () => true, onLost = () => undefined }) {
  const requested = preferred === 'auto' ? 'webgpu' : preferred;
  const choices = requested === 'webgpu' && webgpuAvailable ? ['webgpu', 'webgl2'] : ['webgl2'];
  const failures = [];
  for (const kind of choices) {
    if (!isCurrent()) throw new DOMException('Rendererwechsel verworfen', 'AbortError');
    let candidate = null, ready = false, retired = false, lost = null;
    try {
      candidate = await create(kind, reason => {
        if (retired) return;
        lost = new Error(String(reason || 'Grafikverbindung unterbrochen'));
        if (ready) onLost(lost);
      });
      if (!isCurrent()) throw new DOMException('Rendererwechsel verworfen', 'AbortError');
      if (lost) throw lost;
      if (candidate.metadata?.actual !== kind) throw new Error('Unerwartetes Grafikbackend');
      ready = true;
      return { backend: candidate, kind, fallback: requested === 'webgpu' && kind !== requested, failures };
    } catch (error) {
      retired = true;
      // A rejected factory is responsible for its partial initialization. A
      // returned but stale/lost candidate belongs to this selection attempt.
      await candidate?.dispose();
      if (!isCurrent() || error.name === 'AbortError') throw error;
      failures.push({ kind, message: String(error.message || error) });
      if (kind === choices.at(-1)) throw error;
    }
  }
  throw new Error('Kein Grafikbackend verfügbar');
}
